import { GetStaticProps } from 'next';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import { b2cData } from '../../../../components/cms/layout/components/header';
import { AllIntegrations } from '../../../../components/itr2/integrations';
import { returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';

const IntegrationsPage = (): JSX.Element => {
  return (
    <>
      <ClearInNavbar data={b2cData} />
      <AllIntegrations />
    </>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default IntegrationsPage;
